import { render, staticRenderFns } from "./complaintForm.vue?vue&type=template&id=a2fb9254"
import script from "./complaintForm.vue?vue&type=script&lang=js"
export * from "./complaintForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports